import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AdminView from './views/AdminView';
import LandingView from './views/LandingView';
import StationsView from './views/StationsView';
import LoadingView from './views/LoadingView';
import PlayerView from './views/PlayerView';
import { ChartGameView } from './views/ChartGameView';
 
// export type Track = {
//   id: string;
//   title: string;
//   duration: number;
//   previewURL: string;
// };
 
export const SNIPPIT_API_URL = process.env.REACT_APP_SNIPPIT_API_URL
export const SNIPPIT_GAME_URL = process.env.REACT_APP_SNIPPIT_GAME_URL

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingView />} />
        <Route path="/stations" element={<StationsView />} />
        <Route path="/loading" element={<LoadingView />} />
        <Route path="/player/:gameMode" element={<PlayerView />} />
        <Route path="/chart-game" element={<ChartGameView/>} />
        <Route path="/admin" element={<AdminView/>} />
      </Routes>
    </BrowserRouter>
  );
}
 